<template>
  <div class="wx-record-component"
       @click="handleClickRecordBtn"
  >
    <template v-if="recording">
      <p class="wx-record-duration">{{ duration }}s</p>
      <span class="wx-record-dot"></span>
    </template>
    <div class="wx-record-status"></div>
    <div class="wx-record-btn">
      <ym-icon :class="[this.recording ? 'is-stop' : 'is-recording']"
                :name="icon"
      />
    </div>
    <span class="wx-record-text">{{ text }}</span>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import { TimePool } from '@/utils/timer';
  import { MAX_RECORD_DURATION } from '@/utils/constant';
  import { getRecordAuth, setRecordAuth } from '@/utils';

  export default {
    name: 'WxRecord',
    data() {
      return {
        auth: getRecordAuth(),
        disabled: false,
        recording: false,
        end: false,
        duration: 0,
        interval: new TimePool().getTimer(1000),
        intervalIndex: -1,
        localId: '',
      };
    },
    props: {
      edit: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      ...mapGetters([
        'player',
      ]),
      text() {
        if (this.recording) {
          return '完成录音';
        }
        if (this.edit || this.end) {
          return '重新录音';
        }
        return '点击录音';
      },
      icon() {
        return this.recording ? 'stop-fill' : 'microphone-fill';
      },
    },
    watch: {
      recording(val) {
        if (val) {
          this.$emit('recording', val);
        }
      },
    },
    methods: {
      clearTimer() {
        this.interval.remove(this.intervalIndex);
        this.duration = 0;
      },
      handleStopRecord(localId) {
        this.recording = false;
        this.end = true;
        this.localId = localId;
        const { duration } = this;
        this.$emit('end', {
          localId,
          duration,
        });
        this.clearTimer();
        this.disabled = false;
      },
      async listenRecordEnd() {
        try {
          // 监听录音结束
          const res = await this.$wechat.onVoiceRecordEnd();
          this.handleStopRecord(res.localId);
        } catch (e) {
          this.$dialog.alert({
            message: '发生了错误，请刷新页面重新录音',
            confirmButtonText: '好的',
            closeOnClickOverlay: false,
          }).then(() => {
            this.$emit('error');
          });
        }
      },
      handleRecording() {
        this.recording = true;
        this.end = false;
        this.interval = new TimePool().getTimer(1000);
        const max = MAX_RECORD_DURATION;
        this.intervalIndex = this.interval.add(() => {
          this.duration += 1;
          if (this.duration > max) {
            this.clearTimer();
          }
        });
        this.listenRecordEnd();

        if (this.auth !== 'true') {
          setRecordAuth();
        }

        setTimeout(() => {
          this.disabled = false;
        }, 1000);
      },
      async handleClickRecordBtn() {
        const { player } = this;
        // 有在播放的音频，则暂停
        const { playingId } = player;
        if (playingId > 0) {
          player.pause();
        }

        // 上一次操作尚未结束
        if (this.disabled) {
          this.$toast('操作过于频繁');
          return;
        }

        // 禁止快速点击
        this.disabled = true;

        if (!this.recording) {
          try {
            // 开始录音
            await this.$wechat.startRecord();
          } catch (res) {
            const { errMsg } = res;
            if (errMsg !== 'startRecord:recording') {
              this.$dialog.alert({
                message: '好像出错咯~请刷新页面',
                confirmButtonText: '好的',
                closeOnClickOverlay: false,
              }).then(() => {
                this.$emit('error');
              });
              return;
            }
          }
          // 处理录音中
          this.handleRecording();
          return;
        }
        try {
          // 暂停录音
          const res = await this.$wechat.stopRecord();
          // 处理录音结束
          this.handleStopRecord(res.localId);
        } catch (e) {
          this.$dialog.alert({
            message: '发生错误，请刷新页面重新录音',
            confirmButtonText: '好的',
            closeOnClickOverlay: false,
          }).then(() => {
            this.$emit('error');
          });
        }
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';
  @import '~@/assets/styles/mixins.less';

  .wx-record-component {
    display: inline-block;
    text-align: center;
    line-height: 1;
    font-size: @font-size-large;
    font-weight: @font-weight-primary;
  }

  .wx-record-duration {
    color: @color-text-lighter;
    margin: 0 auto @size-small;
  }

  .wx-record-dot {
    display: block;
    width: 20px;
    height: 20px;
    border-radius: @border-radius-round;
    margin: 0 auto @size-small;
    background: @color-highlight;
    opacity: 1;
    animation: dot 1s infinite ease;
  }

  .wx-record-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    width: @record-size;
    height: @record-size;
    border-radius: @border-radius-round;
    color: @color-white;
    margin: 0 auto @size-base;
    .training-gradient-primary();
    .is-recording {
      font-size: 72px;
    }
    .is-stop {
      font-size: 24px;
    }
  }

  .wx-record-text {
    color: @training-text-primary;
  }

  @keyframes dot {
    0% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }
</style>
